import React, { useEffect, useState } from 'react';

// import { ReactComponent as SVGBorder } from 'svg/feature-border.svg';
// import { ReactComponent as SVGBorderHorizontal } from 'svg/feature-border-horizontal.svg';

import * as Styled from './Feature.styles';
import useGlobalStore from 'utils/store';
import { ScenesManager } from 'webgl/scenes/ScenesManager';
import { IFeature } from 'data/content.types';
import { fadeMotionProps } from 'utils/styles/animations';
import { isDesktop } from 'utils/platform';

export interface FeatureProps {}

const Feature: React.FC<FeatureProps> = () => {
  const { copy } = useGlobalStore();
  const [featureCopy, setFeatureCopy] = useState<IFeature>({
    title: '',
    subtitle: '',
    description: '',
  });

  useEffect(() => {
    if (copy &&
      ScenesManager.currentFeatureName !== "" &&
      copy.features[ScenesManager.currentFeatureName]
    ) {
      setFeatureCopy(copy.features[ScenesManager.currentFeatureName])
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

return <Styled.Wrapper {...fadeMotionProps} style={{
  top: ScenesManager.currentFeature2D.y,
  left: ScenesManager.currentFeature2D.x,
}}>
    {/* {isDesktop() ? <SVGBorderHorizontal /> : <SVGBorder /> } */}
    <Styled.Content>
    {/* 
      <Styled.Title  
        {...fadeMotionProps}
        transition={{ delay: 0.7 }}
        dangerouslySetInnerHTML={{ __html: featureCopy.title }}
      />
     */}  
      <Styled.SubTitle  
        {...fadeMotionProps}
        transition={{ delay: 0.8 }}
        dangerouslySetInnerHTML={{ __html: featureCopy.subtitle }}
      />
      <Styled.Description  
        {...fadeMotionProps}
        transition={{ delay: 0.9 }}
        dangerouslySetInnerHTML={{ __html: featureCopy.description }}
      />
    </Styled.Content>
  </Styled.Wrapper>;
};

export default Feature;
